import React, { ReactNode } from 'react'

import icon from 'assets/icons/search.svg'

import classes from './Empty.module.scss'

type Props = {
  absolute?: boolean
  title?: ReactNode
  description?: ReactNode
}
const defaultDescription = (
  <>
    Поищите по другим ключевым словам <br /> или уберите применённые фильтры
  </>
)
export const Empty = ({
  absolute,
  description = defaultDescription,
  title,
}: Props): JSX.Element => {
  return (
    <div className={`${classes.empty} ${absolute && classes.absolute}`}>
      <img src={icon} alt="empty_icon" />
      <h3 className={classes.title}>{title || 'Результатов не найдено'}</h3>
      <div className={classes.description}>{description}</div>
    </div>
  )
}
